import {isNil} from 'ramda';

import {TEMPLATE_TOKEN} from './TEMPLATE_TOKEN';
import {TemplateTokenBlot} from './TemplateTokenBlot';

/**
 * Turns the editor HTML into ordinary e-mail HTML: every token becomes its canonical
 * `{{ code }}` text. HTML without tokens is returned unchanged.
 */
export function serializeTemplateTokens(html: string) {
  if (!html.includes(TEMPLATE_TOKEN.className)) {
    return html;
  }

  const document = new DOMParser().parseFromString(html, 'text/html');
  const tokenNodes = document.body.querySelectorAll(`span.${TEMPLATE_TOKEN.className}`);

  if (tokenNodes.length === 0) {
    return html;
  }

  tokenNodes.forEach((node) => {
    const value = TemplateTokenBlot.value(node);
    const text = isNil(value)
      ? (node.textContent ?? '').replace(TEMPLATE_TOKEN.guardPattern, '')
      : TEMPLATE_TOKEN.toPlaceholder(value.code);

    node.replaceWith(document.createTextNode(text));
  });

  return document.body.innerHTML;
}
